<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70" />
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>

          </b-navbar-nav>
          <b-navbar-brand center>{{ $route.name }}</b-navbar-brand>
          <b-navbar-nav class="ml-auto"></b-navbar-nav>
        </b-navbar>
        <b-container fluid>
          <b-row>
            <b-col cols="12" sm="12" md="6" lg="6"></b-col>
            <b-col cols="12" sm="12" md="6" lg="6" class="text-right"></b-col>
            <b-col cols="12" sm="12" md="6" lg="12">
              <b-card class="formCard">
                <b-card-text>
                  <b-row>
                    <b-col cols="12" sm="6" md="3">
                      <label for="caf_tpt_type">Transportation By <span class="error">*</span></label>
                      <model-list-select
                        :isDisabled="form.caf_id > 0 && $sessionsStorage.get('nameUser') != 'Bhavneesh' ? true : false"
                        :list="TPTtypeList" v-model="form.caf_tpt_type" option-value="ccTypeVal" option-text="ccTypeTxt"
                        placeholder="Select Transportation By"
                        :style="{ borderColor: !form.caf_tpt_type && errorList.caf_tpt_type ? 'red' : '', }" />
                      <span class="error" v-if="!form.caf_tpt_type">{{ errorList.caf_tpt_type }}</span>
                    </b-col>

                    <b-col cols="12" sm="6" md="3">
                      <label for="caf_transport_type">Movement Type <span class="error">*</span></label>
                      <model-list-select :isDisabled="form.caf_id > 0 &&
                        $sessionsStorage.get('nameUser') != 'Bhavneesh'
                        ? true : false
                        " :list="movementTypeList" v-model="form.caf_transport_type" option-value="val"
                        option-text="text" placeholder="Select "
                        :style="{ borderColor: !form.caf_transport_type && errorList.caf_transport_type ? 'red' : '', }" />
                      <span class="error" v-if="!form.caf_transport_type">{{ errorList.caf_transport_type }}</span>
                    </b-col>
                    <b-col cols="12" sm="6" md="3">
                      <label>CAF Date</label>
                      <date-picker
                        v-if="$sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh'"
                        :disabled="form.caf_id > 0 && $sessionsStorage.get('nameUser') != 'Bhavneesh' ? true : false"
                        :format="selectDateFormat" lang="en" width="100%" v-model="form.caf_date" type="date"
                        id="caf_date" placeholder="GRN Date"
                        :style="{ borderColor: !form.caf_date && errorList.caf_date ? 'red' : '', }" />
                      <span class="error" v-if="!form.caf_date">{{ errorList.caf_date }}</span>
                    </b-col>
                    <b-col cols="12" sm="6" md="3">
                      <label for="fk_cont_type_id">Container Type. <span class="error">*</span></label>
                      <model-list-select :list="$store.getters['common/getAllContainerTypeList']"
                        :isDisabled="form.caf_id > 0 ? true : false" v-model="form.fk_cont_type_id"
                        option-value="containerTypeId" option-text="containerType" placeholder="Select Container Type"
                        :style="{ borderColor: !form.fk_cont_type_id && errorList.fk_cont_type_id ? 'red' : '', }"></model-list-select>
                      <span class="error" v-if="!form.fk_cont_type_id">{{ errorList.fk_cont_type_id }}</span>
                    </b-col>
                    <b-col cols="12" sm="6" md="3">
                      <label for="fk_client_id">Shipper Name. <span class="error">*</span></label>
                      <model-list-select :list="$store.getters['common/getAllClientList']" id="clientform"
                        @input="getStuffingLocation($event)" v-model="form.fk_client_id" option-value="clientId"
                        option-text="clientName" placeholder="Select SHIPPER" required :style="{
                          borderColor: !form.fk_client_id && errorList.fk_client_id ? 'red' : '',
                        }">
                      </model-list-select>
                      <span class="error" v-if="!form.fk_client_id">{{ errorList.fk_client_id }}</span>
                    </b-col>
                    <b-col cols="12" sm="6" md="3">
                      <label for="fk_vehicle_id">Vehicle No. <span class="error">*</span></label>
                      <model-list-select :list="$store.getters['commonDropdownMaster/getAllVehicleDDList']"
                        v-model="form.fk_vehicle_id" option-value="value" option-text="label"
                        placeholder="Select Vehicle No"
                        :style="{ borderColor: !form.fk_vehicle_id && errorList.fk_vehicle_id ? 'red' : '', }" />
                      <span class="error" v-if="!form.fk_vehicle_id">{{ errorList.fk_vehicle_id }}</span>
                    </b-col>

                    <!-- <b-col cols="12" sm="6" md="3">
                      <label for="fk_driver_id">Driver Name <span class="error">*</span></label>
                      <model-list-select :list="$store.getters['commonDropdownMaster/getAllDriverDDList']"
                        id="driver_id" v-model="form.fk_driver_id" option-value="value" option-text="label"
                        placeholder="Select Driver Name" required :style="{
                          borderColor: !form.fk_driver_id && errorList.fk_driver_id ? 'red' : '',
                        }" />
                      <span class="error" v-if="!form.fk_driver_id">{{ errorList.fk_driver_id }}</span>
                    </b-col> -->
                    <b-col cols="12" sm="6" md="3">
                      <label for="fk_from_id">From <span class="error">*</span></label>
                      <model-list-select @input="getLocationList($event, 'All', 'finalAllPlaceDataPOR')" @searchchange="
                        getLocationList($event, 'All', 'finalAllPlaceDataPOR')
                        " :list="$store.getters['common/getAllPORList']" v-model="form.fk_from_id"
                        option-value="pickupId" option-text="pickupLocation" placeholder="Select From"
                        :style="{ borderColor: !form.fk_from_id && errorList.fk_from_id ? 'red' : '', }" />
                      <span class="error" v-if="!form.fk_from_id">{{ errorList.fk_from_id }}</span>
                    </b-col>
                    <b-col cols="12" sm="6" md="3">
                      <label for="fk_to_id">To <span class="error">*</span></label>
                      <model-list-select :list="$store.getters['commonDropdownMaster/getAllStuffingList']"
                        v-model="form.fk_to_id" option-value="pickupId" option-text="pickupLocation"
                        placeholder="Select To"
                        :style="{ borderColor: !form.fk_to_id && errorList.fk_to_id ? 'red' : '', }" />
                      <span class="error" v-if="!form.fk_to_id">{{ errorList.fk_to_id }}</span>
                    </b-col>

                    <b-col cols="12" sm="6" md="12" class="justify-content-center mt-2">
                      <b-button style="font-size: 0.675rem" @click="saveContainerAllocation(0)" size="xxl"
                        :disabled="isSubmited" variant="primary">
                        <md-spinner v-if="isSubmited" md-indeterminate style="width: 20px; height: 20px"></md-spinner>
                        {{ form.caf_id > 0 ? 'Update' : 'Save' }}
                      </b-button>
                    </b-col>

                  </b-row>
                </b-card-text>
              </b-card>
            </b-col>
          </b-row>
        </b-container>

      </b-card-text>
    </b-card>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>

  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../../common/customLoader.vue";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import { globalPermissionStatus, GlobalContainerValid, GlobalGetLocation, lastVisitPage } from "../../../helper/collection.js";
import NodeLockPannelService from "../../../services/NodeLockPannelService.js";

export default {
  beforeMount() {
    if (globalPermissionStatus("Transportation")) {
      const storePromises = [
        this.$store.dispatch(
          "common/setAllClientList",
          JSON.stringify({ itemCode: "ClientList", isKYC: "Yes", isBRF: 0 })
        ),
        this.$store.dispatch(
          "common/setAllContainerTypeList",
          JSON.stringify({ itemCode: "ContainerTypeList" })
        ),
        this.$store.dispatch(
          "common/setAllShippingLineList",
          JSON.stringify({ itemCode: "ShippingLineList" })
        ),
        this.$store.dispatch(
          "common/setAllPORList",
          JSON.stringify({
            itemCode: "PORList",
          })
        ),
        this.$store.dispatch(
          "commonDropdownMaster/setAllVehicleDDList",
          JSON.stringify({
            itemCode: "getVehicleList",
            vehicleActiveInactiveId: "1",
          })
        ),
        this.$store.dispatch(
          "commonDropdownMaster/setAllDriverDDList",
          JSON.stringify({
            itemCode: "getDriverList",
            isDriverActive: "1",
          })
        ),];
      const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
      Promise.all(storePromises)
        .then(() => delay(2000)) // Wait for 5 seconds
        .then(() => {
          // After the delay, execute the next function

          let currentDate = new Date();
          this.form.caf_date = this.formatDate(currentDate);
          if (
            this.$sessionsStorage.get("edit_caf_id") != "" &&
            this.$sessionsStorage.get("edit_caf_id") != undefined
          ) {
            this.getCafData(this.$sessionsStorage.get("edit_caf_id"));
          }
        })
        .catch((error) => {
          console.error("Error dispatching store actions:", error);
        });
      this.$store.dispatch("setCurrentRoute", this.$router.history.current.fullPath);
      lastVisitPage(this.$router.history.current.fullPath);
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }


  },
  data() {
    return {
      validate: true,
      isSubmited: false,
      isLoading: false,
      alert: {
        content: "",
        ok: "ok",
      },
      selectDateFormat,
      form: {
        caf_id: this.$sessionsStorage.get("edit_caf_id") != "" && this.$sessionsStorage.get("edit_caf_id") != undefined ? this.$sessionsStorage.get("edit_caf_id") : 0,
        caf_tpt_type: '1',
        caf_transport_type: 'Export',
        caf_date: '',
        fk_vehicle_id: '',
        fk_driver_id: '',
        fk_cont_type_id: '',
        fk_client_id: '',
        fk_from_id: '',
        fk_to_id: '',
      },
      errorList: {
        caf_tpt_type: "",
        caf_transport_type: "",
        caf_date: "",
        fk_cont_type_id: "",
        fk_client_id: "",
        fk_vehicle_id: "",
        
        // fk_driver_id: "",
        // fk_from_id: "",
        // fk_to_id: "",
      },
      formError: [
        "Please Select Transportation By",
        "Please Select Movement Type",
        "Please Select CAF Date",
        "Please Select Container Type",
        "Please Select Shipper Name",
        "Please Select Vehicle No",
        // "Please Select Driver Name",
        // "Please Select From",
        // "Please Select To",
      ],
      TPTtypeList: [
        {
          ccTypeVal: "1",
          ccTypeTxt: "Pridel",
        },
        {
          ccTypeVal: "2",
          ccTypeTxt: "Outsourced",
        },
      ],
      movementTypeList: [
        {
          text: "EXPORT",
          val: "Export",
        },
        {
          text: "IMPORT",
          val: "Import",
        },
        {
          text: "EMPTY REPO",
          val: "Empty_Repo",
        },
      ],
    };
  },

  mounted() { },

  beforeDestroy() {
  },
  destroyed() { },
  components: {
    DatePicker,
    ModelListSelect,
    CustomLoader,
  },
  computed: {

  },
  watch: {

  },
  methods: {
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear(),
        minute = d.getMinutes(),
        Hour = d.getHours(),
        second = d.getSeconds();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      let dateNew = [year, month, day].join("-");
      let minuteNew = [Hour, minute].join(":");

      return dateNew;
      // return dateNew + " " + minuteNew;
    },
    getCafData(caf_id) {
      this.isLoading = true;
      NodeLockPannelService.getSingleContainerAllocation(caf_id)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log("data PS=>", data.data);
          if (status == 200 && data) {
            this.getStuffingLocation(data.data.fk_client_id)
            let item = data.data;
            this.isLoading = false;
            this.form = item;
          }
        })
        .catch((error) => {
          console.log("Catch on getContainerAllocationList Error: ", error);
        });
    },
    saveContainerAllocation() {
      this.validateContainerAllocation();
      if (this.validate) {
        this.isLoading = true;
        this.isSubmited = true;
        NodeLockPannelService.upsertContainerAllocation(this.form)
          .then((response) => {
            const { data, status, statusText } = response;

            if (status == 200 && data) {
              this.isSubmited = false;
              this.alert.content = data.message;
              this.$refs["addPop"].open();
            }
            this.isSubmited = false;
            this.isLoading = false;
          })
          .catch((error) => {
            this.isSubmited = false;
            console.log("Catch on saveContainerAllocation Error: ", error);
          });
      } else {
        this.isLoading = false;
      }

    },
    validateContainerAllocation() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (this.form[x] == "" || this.form[x] == undefined || this.form[x] == null) {
          this.errorList[x] = this.formError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    clearError() {
      this.errorList = {
        caf_tpt_type: "",
        caf_transport_type: "",
        caf_date: "",
        fk_vehicle_id: "",
        fk_driver_id: "",
        fk_cont_type_id: "",
        fk_client_id: "",
        fk_from_id: "",
        fk_to_id: "",
      };
    },
    goBack() {
      window.history.go(-1);
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },

    getStuffingLocation(clientId) {

      if (clientId) {
        this.$store.dispatch(
          "commonDropdownMaster/setAllStuffingDDList",
          JSON.stringify({
            itemCode: "AllStuffingList",
            clientId: clientId,
          })
        );
      }
    }

  },


};
</script>
<style>
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// containerAllocationForm.vue?1a540ece